export default "__VITE_ASSET__7FsoCDRl__"